
export const statisticsData = [
    {
        result: "73+",
        description: "NFT collections found",
    },
    {
        result: "127%",
        description: "Average growth rate of collections",
    },
];
